






















































































































import CreateDialog from '@/components/CreateDialog.vue'
import { editMixin } from '@/utils/mixins/editMixin'
import { AgencyTopUpPrice } from '@/utils/interfaces/topup.interface'
import { getAgencies } from '@/api/Agency/agency.api'
import {
  createOrUpdateAgencyPrice,
  createOrUpdateSharedProduct,
  getProducts,
  getProviders,
} from '@/api/Topup/topup.api'
import { number, required } from '@/utils/validators'
import { crudMixin } from '@/utils/mixins/crudMixin'
import mixins from 'vue-typed-mixins'
import { SelectItem, VueForm } from '@/utils/interfaces'
import Autocomplete from '@/components/Autocomplete.vue'
import { getAgencyProviders, getAgencySharedProviders } from '@/utils/functions'

export default mixins(editMixin, crudMixin).extend({
  components: {
    appCreateDialog: CreateDialog,
    appAutocomplete: Autocomplete,
  },
  props: {
    shared: Boolean,
  },
  data() {
    return {
      rules: {
        required: (value: string) =>
          required(value) || this.$t('validation.field-required'),
        numeric: (value: string) =>
          number((value || '').toString()) ||
          this.$t('validation.must-be-a-number'),
        greaterThan: (value: number) =>
          value > 0 ||
          this.$t('validation.must-be-greater-than-equal', { value: 0 }),
        lowerThan: (value: number) =>
          value <= 10 ||
          this.$t('validation.must-be-lower-than-equal', { value: 10 }),
      },
      crud: {} as AgencyTopUpPrice,
      defaultCrud: {
        agency: this.$store.getters.agency.uuid,
        price: 19,
        product: '',
        is_active: true,
        rate: 1,
      } as AgencyTopUpPrice,
      getAgencies: getAgencies,
      getProviders: getProviders,
      getAgencyProviders: getAgencyProviders,
      getSharedProviders: getAgencySharedProviders,
      loading: {
        general: false,
        products: false,
      },
      products: [] as SelectItem[],
    }
  },
  computed: {
    disabled(): boolean {
      return !!this.crud.shared_provider && !this.shared
    },
  },
  methods: {
    async onSuccess() {
      if (!(this.$refs.form as VueForm).validate()) return
      try {
        this.loading.general = true
        let response
        if (this.crud.shared_provider) {
          response = await createOrUpdateSharedProduct(this.crud)
        } else response = await createOrUpdateAgencyPrice(this.crud)
        this.resetCrud()
        ;(this.$refs.form as VueForm).resetValidation()
        this.$emit('new-price', response.data)
        this.$emit('input', false)
      } finally {
        this.loading.general = false
      }
    },
  },
  async mounted() {
    this.loading.products = true
    try {
      const response = await getProducts({ limit: 200 })
      this.products = response.data.results.map(product => ({
        text: product.full_code,
        value: product.uuid,
      }))
    } finally {
      this.loading.products = false
    }
  },
})
